import { render, staticRenderFns } from "./Marges.vue?vue&type=template&id=48e7c125&scoped=true"
import script from "./Marges.vue?vue&type=script&lang=js"
export * from "./Marges.vue?vue&type=script&lang=js"
import style0 from "./Marges.vue?vue&type=style&index=0&id=48e7c125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7c125",
  null
  
)

export default component.exports